var map = {
	"./building.png": "d994",
	"./carousel-1.png": "0296",
	"./carousel-2.png": "04d4",
	"./carousel-3.png": "8aaa",
	"./carousel-4.png": "34ad",
	"./cert1.png": "810b",
	"./cert2.png": "b87d",
	"./cert3.png": "89ba",
	"./cert4.png": "f346",
	"./cert5.png": "9f48",
	"./compresor-1.png": "9515",
	"./compresor-2.png": "0084",
	"./compresor-3.png": "7e98",
	"./imagen-air.png": "2164",
	"./logo.svg": "9b19",
	"./wave-2.svg": "da89",
	"./wave.svg": "46db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";